export enum RemovalModals {
  AccountingRemoval,
  CannotRemovePlatform,
  ConfirmRemovePlatform,
  ManagementAccountsRemoval,
  OptionalDocumentRemoval,
  RequiredDocumentRemoval,
  BankConnectionRemoval,
}

export { AccountingRemovalModal, ManagementAccountsRemovalModal } from "./accounting-removal-modal";
export { BankConnectionRemovalModal } from "./bank-connection-removal";
export { CannotRemovePlatformModal } from "./cannot-remove-platform-modal";
export { ConfirmPlatformRemovalModal } from "./confirm-platform-removal-modal";
export { OptionalDocumentRemovalModal } from "./optional-document-removal-modal";
export { RequiredDocumentRemovalModal } from "./required-document-removal-modal";
